

































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import api from '@/api';
import slugify from '@/slugify';

@Component({})
export default class Home extends Vue {
  private result: any = {};
  private loading: boolean = false;
  private mobile: boolean = false;
  private slugify = slugify;
  private type = '';
  private encodeCurrentUrl = '';
  private currentUrl = '';
  private googleScheme(text: string) {
    return encodeURIComponent(btoa(text)).replace(/%2F/g, '_');
  }
  private encode(text: string) {
    return encodeURIComponent(text);
  }
  private mounted() {
    this.mobile = window.innerWidth < 500;
    this.currentUrl = location.href;
    this.encodeCurrentUrl = encodeURIComponent(location.href);
    this.loading = true;
    const slug = this.$route.params.slug;
    this.type = this.$route.path.split('/')[1];
    api(`https://itunes.apple.com/search?term=${encodeURIComponent(
      slug.split('-')[slug.split('-').length - 1],
    )}&limit=1`)
      .then((result: any) => {
        this.result = result[0];
      })
      .then(() => this.loading = false);
  }
}
